import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['dialogBody', 'dialog'];
  static values = {
    newUrl: String
  };

  new(e) {
    e.preventDefault();
    this.loadForm(this.newUrlValue);
  }

  edit(e) {
    e.preventDefault();
    this.loadForm(e.target.dataset.strategyNoteEditUrl);
  }

  loadForm(url) {
    fetch(url)
      .then((res) => res.text())
      .then((html) => {
        this.dialogBodyTarget.innerHTML = html;
        this.dialogTarget.isOpen = true;
      });
  }
}
